export default __webpack_public_path__ + "static/media/indian_ladies.8fa5cfb9.png";